import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'
import AppBar from '../components/app-bar'
import { 
  Button, 
  Box, 
  AppBar as AppBarHistory, 
  CircularProgress, 
  Typography, 
  TableContainer, 
  makeStyles, 
  Select, 
  MenuItem, 
  Divider, 
  InputLabel, 
  FormControl, 
  ListItemText, 
  TextField, 
  Checkbox, 
  Dialog, 
  Popover, 
  Slider 
} from '@material-ui/core'
import { customTheme } from '../styling'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import axiosInstance from '../axios'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import languageTargetIcon from '../images/translator/language-target.svg'
import AddIcon from '@mui/icons-material/Add';
import videoSvg from '../images/video.svg'
import mp3svg from '../images/mp3.svg'
import AudioPlayer from './audio-player/audio-player';
import iconWord from '../images/icon-word.svg'
import iconPdf from '../images/icon-pdf.svg'
import iconClean from '../images/icon-clean.svg'
import DownloadIcon from '@mui/icons-material/Download'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import moment from 'moment'
import { openaiSync, toBase64, openaiAssistantAsync, readDodWord, registerCost, rewriteMathToWords } from '../utils'
import forbidden from '../images/403.jpg'
import CachedIcon from '@mui/icons-material/Cached'
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { PDFDocument } from 'pdf-lib'
// pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`
import cable from '../cable'

const API_URL = `${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1`
const API_BASE = process.env.REACT_APP_BACKOFFICE_API_DOMAIN

const DEBUG = true

const ACCEPTED_IMAGE_LABEL = 'JPG, JPEG, PNG'
const ACCEPTED_IMAGE_MIME = ['image/jpeg', 'image/png']
const ACCEPTED_IMAGE_EXT = ['.jpg', '.jpeg', '.png']

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },

  textarea: {
    fontSize: '1rem',
    border: '1px solid #000',
    paddingLeft: '0.5rem',
    paddingTop: '0.5rem',
    border: 'none',
    borderColor: 'none',
    resize: 'none',
    width: '100%',
    borderRadius: 15,
    height: '53vh',
    boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
    '&:focus': {
      outline: 'none !important',
      outlineColor: '#B91F26',
      border: '1px solid #ba1f26 !important'
    },
  },

  input: {
    position: 'relative',
    top: '0.5rem',
    marginLeft: '1rem',
  },
  formControl: {
    minWidth: 250, marginRight: '1.5rem',
  },
}))

const styleOfImages = [
  {
    id: 1, text: 'Libero', value: 'Libero',
  },
  {
    id: 2, text: 'Illustrazione', value: 'Create a modern flat vector illustration in a professional and clean style, using a color palette of gray, black, and red. The image should convey a finance-related theme, integrating key financial symbols such as coins, dollar signs, graphs, or other relevant elements. Design the scene against a white background with a dynamic and balanced composition, incorporating minimalist details like abstract shapes, plants, or geometric patterns. Add [USER DESCRIPTION] as part of the scene to customize the illustration. Ensure the artwork feels professional, sleek, and in a flat, approachable aesthetic, with minimal shading and clean, bold design.',
  },
  {
    id: 3, text: 'Realistico finance', value: 'Create a realistic, high-quality image with a classic finance theme. The image should depict a professional environment or financial activity, incorporating elements such as electronic devices, like smartphones, tablets, or laptops, graphs, charts, or financial data overlays in glowing or semi-transparent styles. Use a dark, elegant color scheme with accents of red, gray, and black for a professional aesthetic. Include blurred or abstract modern office surroundings or soft bokeh lighting for depth and atmosphere. Add [USER DESCRIPTION] to customize the scene. Maintain a sharp, photorealistic finish to emphasize professionalism and financial focus.',
  },
]


const languages = [
  {
    id: 1, text: 'Italiano', value: 'it',
  },
  {
    id: 2, text: 'Inglese', value: 'en',
  },
  {
    id: 3, text: 'Francese', value: 'fr',
  },
  {
    id: 4, text: 'Greco', value: 'el',
  },
  {
    id: 5, text: 'Portoghese', value: 'pt',
  },
  {
    id: 6, text: 'Spagnolo', value: 'es',
  },
  {
    id: 7, text: 'Tedesco', value: 'de',
  }
]

const PRONUNCIATION_ASSISTANT = {
  'Italiano': 'asst_USOfAygsXBSAf0G8ai7979Vi', 
  'Inglese': 'asst_i3ajVhKkwFSCI3LeXODrB0To', 
  'Francese': 'asst_QwFgw71gKF2njoTZ3ODKhjGx', 
  'Greco': 'asst_UjaoBOlFOVhKV0u8DZEgyteQ', 
  'Portoghese': 'asst_CCl4yT1m5fmjzdp3JVFFFDSZ', 
  'Spagnolo':'asst_LreRj7W4BQQnhwDMDIMcfRoP', 
  'Tedesco': 'asst_1vLtPueBcxPDQxDHrlg88ziF'
}







const VideoComponent = () => {
  const history = useHistory()
  const { projectId } = useParams()
  const matchEdit = useRouteMatch('/video-maker/:projectId/edit')
  const isEditRoute = Boolean(matchEdit)
  const { enqueueSnackbar } = SnackBar.Consumer()
  const [type, setType] = useState(null)
  const [openNewProject, setOpenNewProject] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [nameOfTheProject, setNameOfTheProject] = useState('')
  const [wordText, setWordText] = useState('')
  const [newTextAudio, setNewTextAudio] = useState('')
  const classes = useStyles()
  const [fileType, setFileType] = useState(1)
  const [generating, setGenerating] = useState(false)
  const [saving, setSaving] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false)
  const [savingNewAudio, setSavingNewAudio] = useState(false)
  const [language, setLanguage] = useState('')
  const [voiceTarget, setVoiceTarget] = useState([])
  const [formatImage, setFormatImage] = useState(null)
  const [textarea, setTextarea] = useState('')
  const [imageGenerated, setImageGenerated] = useState(null)
  const [view, setView] = useState(1)
  const [currentPopover, setCurrentPopover] = useState(null)
  const [currentPopoverEdit, setCurrentPopoverEdit] = useState(null)
  const [orderBy, setOrderBy] = useState('status')
  const [savedAudioModalOpen, setSavedAudioModalOpen] = useState(false)
  const [savedAudio, setSavedAudio] = useState([])
  const [order, setOrder] = useState('asc')
  const [files, setFiles] = useState([])
  const [files2, setFiles2] = useState([])
  const [files3, setFiles3] = useState([])
  const [currentSlidEdit, setCurrentSlidEdit] = useState(null)
  const inputRef = useRef(null)
  const inputRef2 = useRef(null)
  const inputRef3 = useRef(null)
  const [audioList, setAudioList] = useState([])
  const [textToSpeechProcessing, setTextToSpeechProcessing] = useState(false)
  const [speechToTextProcessing, setSpeechToTextProcessing] = useState(JSON.parse(localStorage.getItem('speechToTextProcessing')))
  const [nameProject, setNameProject] = useState('')
  const [filesUploaded, setFilesUploaded] = useState([])
  const [filesUploaded2, setFilesUploaded2] = useState([])
  const [newProject, setNewProject] = useState(null)
  const [deletingFile, setDeletingFile] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(null)
  const [slide, setSlide] = useState(null)
  const [loading, setLoading] = useState(false)
  const [listEditedSlides, setListEditedSlides] = useState([])
  const [userDetails, setUserDetails] = useState(null)
  const [hovered, setHovered] = useState(null);
  const [loadedImages, setLoadedImages] = useState({}) // { [imageId]: true }
  const [pdfPages, setPdfPages] = useState(null)
  const [regeneratingSections, setRegeneratingSections] = useState(new Set())
  const subscriptionsRef = useRef({})
  const [projectsLoading, setProjectsLoading] = useState(true);
  const [userLoading, setUserLoading] = useState(true);





  const normalizeFileUrl = (url) => {
    if (!url) return url
    if (url.startsWith('blob:') || url.startsWith('data:')) return url

    try {
      const target = new URL(url)
      const base = new URL(API_BASE)
      target.protocol = base.protocol
      target.host = base.host
      return target.toString()
    } catch (e) {
      return url
    }
  }


  useEffect(() => {
    if (!projectId) {
      setNewProject(null)
      setSlide(null)
      return
    }

    // já temos o projeto carregado? reaproveita
    if (newProject && String(newProject.id) === projectId) {
      setSlide(isEditRoute ? newProject : null)
      return
    }

    setLoading(true)
    axiosInstance.get(`${API_URL}/video_projects/${projectId}`)
      .then(async res => {
        const project = res.data.payload.video_project
        const cloned = await handleSetNewProject(project)
        setSlide(isEditRoute ? cloned : null)
      })
      .catch(() => enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE }))
      .finally(() => setLoading(false))
  }, [projectId, isEditRoute, newProject])



  const subscribeToSection = (sectionId) => {
    console.log('[Cable] subscribing section', sectionId)
    if (!sectionId) return
    if (subscriptionsRef.current[sectionId]) return

    subscriptionsRef.current[sectionId] = cable.subscriptions.create(
      { channel: 'VideoScriptSectionChannel', section_id: sectionId },
      handleSectionMessage(sectionId)
    )
  }

  const handleSectionMessage = (sectionId) => ({
    received: (data) => {
      if (data.status === 'done') {
        removeRegenerating(sectionId)
        reloadCurrentProject(API_URL)
        enqueueSnackbar({ variant: 'success', message: `Audio slide ${sectionId} rigenerato` })
      } else if (data.status === 'error') {
        removeRegenerating(sectionId)
        enqueueSnackbar({ variant: 'error', message: data.message || 'Errore nella rigenerazione' })
      }
    }
  })


  useEffect(() => {
    if (!slide) return

    slide.scripts[0].video_script_sections.forEach(section => {
      subscribeToSection(section.id)
    })

    return () => {
      slide?.scripts?.[0]?.video_script_sections.forEach(section => {
        const sub = subscriptionsRef.current[section.id]
        if (sub) {
          sub.unsubscribe()
          delete subscriptionsRef.current[section.id]
        }
      })
    }
  }, [slide?.id])
        
      
    
  
  
  const waitForSectionAudio = async (sectionId, API_URL, { timeoutMs = 120_000, intervalMs = 2000 } = {}) => {
    const started = Date.now()
    while (Date.now() - started < timeoutMs) {
      const res = await axiosInstance.get(`${API_URL}/video_script_sections/${sectionId}`)
      const section = res.data.payload.video_script_section
      if (section.generated_at && section.audio?.file_url) return section
      if (section.status === 'error') {
        throw new Error('Rigenerazione fallita')
      }
      await new Promise(resolve => setTimeout(resolve, intervalMs))
    }
    throw new Error('Timeout esperando rigenerazione audio')
  }

  const reloadCurrentProject = async (API_URL) => {
    const res = await axiosInstance.get(`${API_URL}/video_projects/${slide.id}`)
    setSlide(res.data.payload.video_project)
    setNewProject(res.data.payload.video_project)
  }

  const addRegenerating = (sectionId) => {
    setRegeneratingSections(prev => new Set(prev).add(sectionId))
  }

  const removeRegenerating = (sectionId) => {
    setRegeneratingSections(prev => {
      const next = new Set(prev)
      next.delete(sectionId)
      return next
    })
  }

  
  const SPEED_VALUES = [1, 1.1, 1.2, 1.5, 2]
  const SPEED_MARKS = [
    { value: 0, label: '1x' },
    { value: 1, label: '1.1x' },
    { value: 2, label: '1.2x' },
    { value: 3, label: '1.5x' },
    { value: 4, label: '2x' }
  ]
  const [globalSpeedIdx, setGlobalSpeedIdx] = useState(0) // velocidade para gerar vídeo

  const [sectionSpeedIdx, setSectionSpeedIdx] = useState(0) // só playback
  const [sectionRates, setSectionRates] = useState({})
  const [editingSectionId, setEditingSectionId] = useState(null)
  const [showSpeedSlider, setShowSpeedSlider] = useState(false)



  
  const canOpenProject = (project) => {
    if (project.kind === 2) {
      return project.audio_status === 'done' && audioHasFile;
    }
    if (project.video_status === 'running' || project.status === 'video_running') return false
    if (project.kind === 2 && !audioHasFile) return false;
    if (project.kind === 2) return true
    if (project.audio_status === 'done') return true
    if (hasLegacyAudio) return true   // libera projetos antigos

    return false
  }


  const getSourceSlideNumber = (image) => {
    if (!image?.filename) return null;
    const match = /__src_(\d+)\./.exec(image.filename);
    return match ? Number(match[1]) : null;
  };

  const slideHasLegacyAudio = (slide?.scripts || []).some(script =>
    (script.video_script_sections || []).some(section => section.audio?.file_url)
  )



  const initialData = async () => {
    try {
      const res1 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`)
      return {
        audioList: [...res1.data.payload.video_projects]
      }

    } catch (error) {

    }
  }

  // useEffect(() => {
  //   if (!projectId) return

  //   setLoading(true)
  //   axiosInstance.get(`${API_URL}/video_projects/${projectId}`)
  //     .then(res => {
  //       const project = res.data.payload.video_project
  //       handleSetNewProject(project)
  //       setSlide(project) // já cai na tela de edição
  //     })
  //     .catch(() =>
  //       enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
  //     )
  //     .finally(() => setLoading(false))
  // }, [projectId])


  // const refetchProjects = async () => {
  //   try {
  //     setLoading(true)
  //     const res = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`)
  //     setAudioList(res.data.payload.video_projects)
  //   } catch (e) {
  //     enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
  //   } finally {
  //     setLoading(false)
  //   }
  // }


  useEffect(() => {
    initialData()
      .then(res => setAudioList(res.audioList))
      .catch(() => enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE }))
      .finally(() => setProjectsLoading(false));

    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`)
      .then(res => setUserDetails(res.data.payload))
      .catch(() => {})
      .finally(() => setUserLoading(false));
  }, [])
  



  const handleBack = async () => {
    // limpa estado de criação/edição
    setSlide(null)
    setView(1)
    setNameOfTheProject('')
    setFiles([])
    setFiles2([])
    setFiles3([])
    setLanguage('')        
    setVoiceTarget([])
    setCurrentSlidEdit(null)
    setCurrentPopover(null)
    setCurrentPopoverEdit(null)
    setNewProject(false)
    history.push('/video-maker')

    // recarrega a lista de projetos
    // refetchProjects()
  }

  const handleFileUpload = async (e) => {
    const filesRaw = Array.from(e.target.files)
    if (!filesRaw) return
    setFiles(filesRaw)
  }

  const handleClickFileUpload = (e) => {

    e.preventDefault()

    if (!inputRef || !inputRef.current) return

    inputRef.current.click()
  }

  const handleFileUpload3 = (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    const okType = ACCEPTED_IMAGE_MIME.includes(file.type)
    const okExt = ACCEPTED_IMAGE_EXT.some(ext => file.name.toLowerCase().endsWith(ext))

    if (!okType && !okExt) {
      enqueueSnackbar({ variant: 'warning', message: `Formato non supportato. Carica un file ${ACCEPTED_IMAGE_LABEL}.` })
      e.target.value = null
      return
    }

    setFiles3([file])
  }

  const handleClickFileUpload3 = (e) => {

    e.preventDefault()

    if (!inputRef3 || !inputRef3.current) return

    inputRef3.current.click()
  }

  const handleFileUpload2 = async (e) => {
    const filesRaw = Array.from(e.target.files || [])
    if (!filesRaw || !filesRaw[0]) return

    const file = filesRaw[0]
    setFiles2(filesRaw)

    try {
      DEBUG && console.group('[PDF] handleFileUpload2')
      DEBUG && console.log('Arquivo PDF:', { name: file.name, size: file.size, type: file.type })

      console.time('[PDF] arrayBuffer')
      const ab = await file.arrayBuffer()
      console.timeEnd('[PDF] arrayBuffer')
      DEBUG && console.log('ArrayBuffer bytes:', ab.byteLength)

      console.time('[PDF] PDFDocument.load')
      const doc = await PDFDocument.load(ab)
      console.timeEnd('[PDF] PDFDocument.load')

      const count = doc.getPageCount()
      setPdfPages(count)
      DEBUG && console.log('Páginas do PDF:', count)
      DEBUG && console.groupEnd()
    } catch (e) {
      setPdfPages(null)
      DEBUG && console.error('[PDF] Falha ao ler PDF:', e)
      enqueueSnackbar({ variant: 'error', message: 'Não foi possível ler o PDF' })
      DEBUG && console.groupEnd?.()
    }
  }


  const handleClickFileUpload2 = (e) => {

    e.preventDefault()

    if (!inputRef2 || !inputRef2.current) return

    inputRef2.current.click()
  }

  const asyncOpenAi = async () => {
    
    const text = await readDodWord(files[0])
    
    const voicesBody = languages.filter((lang) => voiceTarget.includes(lang.text)).map((item)=> {return {...item, finalText:''}})

    let force_response = []
    force_response.push({type:0, text: `Original Language:English Target Language: Italian send: Slide 1
Good morning, I'm Gianluca Garbi, CEO of Banca Sistema.
I'd like to present Banca Sistema's strategic plan for the period 2024-2026.
Slide 2
Before we begin, on page 2, you'll find the presentation agenda, which includes:
A brief overview of our growth path since the Group's inception.` })
    force_response.push({type:1, text: `
Slide 1
Buongiorno, sono Gianluca Garbi, Amministratore Delegato di Banca Sistema.
Vorrei presentarvi il piano strategico di Banca Sistema per il periodo 2024-2026.
Slide 2
Prima di iniziare, a pagina 2, troverete l'ordine del giorno della presentazione, che include:
Una breve panoramica del nostro percorso di crescita dalla nascita del Gruppo.` })
    force_response.push({type:0, text: `Original Language:English Target Language: portuguese send: Slide 1
Good morning, I'm Gianluca Garbi, CEO of Banca Sistema.
I'd like to present Banca Sistema's strategic plan for the period 2024-2026.
Slide 2
Before we begin, on page 2, you'll find the presentation agenda, which includes:
A brief overview of our growth path since the Group's inception.` })
    force_response.push({type:1, text: `
Slide 1
Bom dia, sou Gianluca Garbi, CEO do Banca Sistema.
Gostaria de apresentar o plano estratégico do Banca Sistema para o período de 2024 a 2026.
Slide 2
Antes de começarmos, na página 2, você encontrará a pauta da apresentação, que inclui:
Uma breve visão geral da nossa trajetória de crescimento desde a criação do Grupo.`})
    force_response.push({type:0, text: `Original Language:English Target Language: french send: Slide 1
Good morning, I'm Gianluca Garbi, CEO of Banca Sistema.
I'd like to present Banca Sistema's strategic plan for the period 2024-2026.
Slide 2
Before we begin, on page 2, you'll find the presentation agenda, which includes:
A brief overview of our growth path since the Group's inception.` })
    force_response.push({type:1, text: `Slide 1
Bonjour, je suis Gianluca Garbi, PDG de Banca Sistema.
Je souhaite vous présenter le plan stratégique de Banca Sistema pour la période 2024-2026.
Slide 2
Avant de commencer, vous trouverez en page 2 le programme de la présentation, qui comprend :
Un bref aperçu de notre trajectoire de croissance depuis la création du Groupe.` })
    force_response.push({type:0, text: `Original Language:English Target Language: german send: Slide 1
Good morning, I'm Gianluca Garbi, CEO of Banca Sistema.
I'd like to present Banca Sistema's strategic plan for the period 2024-2026.
Slide 2
Before we begin, on page 2, you'll find the presentation agenda, which includes:
A brief overview of our growth path since the Group's inception.` })
    force_response.push({type:1, text: `Slide 1
Guten Morgen, ich bin Gianluca Garbi, CEO von Banca Sistema.
Ich möchte Ihnen den strategischen Plan von Banca Sistema für den Zeitraum 2024–2026 vorstellen.
Slide 2
Bevor wir beginnen, finden Sie auf Seite 2 die Agenda der Präsentation. Diese umfasst:
Einen kurzen Überblick über unseren Wachstumskurs seit der Gründung der Gruppe.`})
    force_response.push({type:0, text: `Original Language:Italian Target Language: English send: Slide 1
Buongiorno, sono Gianluca Garbi, Amministratore Delegato di Banca Sistema.
Vorrei presentarvi il piano strategico di Banca Sistema per il periodo 2024-2026.
Slide 2
Prima di iniziare, a pagina 2, troverete l'ordine del giorno della presentazione, che include:
Una breve panoramica del nostro percorso di crescita dalla nascita del Gruppo.` })
    force_response.push({type:1, text: `Slide 1
Good morning, I'm Gianluca Garbi, CEO of Banca Sistema.
I'd like to present Banca Sistema's strategic plan for the period 2024-2026.
Slide 2
Before we begin, on page 2, you'll find the presentation agenda, which includes:
A brief overview of our growth path since the Group's inception.` })
    force_response.push({type:0, text: `Original Language:Italian Target Language: portuguese send: Slide 1
Buongiorno, sono Gianluca Garbi, Amministratore Delegato di Banca Sistema.
Vorrei presentarvi il piano strategico di Banca Sistema per il periodo 2024-2026.
Slide 2
Prima di iniziare, a pagina 2, troverete l'ordine del giorno della presentazione, che include:
Una breve panoramica del nostro percorso di crescita dalla nascita del Gruppo.` })
    force_response.push({type:1, text: `Slide 1
Bom dia, sou Gianluca Garbi, CEO do Banca Sistema.
Gostaria de apresentar o plano estratégico do Banca Sistema para o período de 2024 a 2026.
Slide 2
Antes de começarmos, na página 2, você encontrará a pauta da apresentação, que inclui:
Uma breve visão geral da nossa trajetória de crescimento desde a criação do Grupo.`})
    force_response.push({type:0, text: `Original Language:Italian Target Language: french send: Slide 1
Buongiorno, sono Gianluca Garbi, Amministratore Delegato di Banca Sistema.
Vorrei presentarvi il piano strategico di Banca Sistema per il periodo 2024-2026.
Slide 2
Prima di iniziare, a pagina 2, troverete l'ordine del giorno della presentazione, che include:
Una breve panoramica del nostro percorso di crescita dalla nascita del Gruppo.` })
    force_response.push({type:1, text: `Slide 1
Bonjour, je suis Gianluca Garbi, PDG de Banca Sistema.
Je souhaite vous présenter le plan stratégique de Banca Sistema pour la période 2024-2026.
Slide 2
Avant de commencer, vous trouverez en page 2 le programme de la présentation, qui comprend :
Un bref aperçu de notre trajectoire de croissance depuis la création du Groupe.` })
    force_response.push({type:0, text: `Original Language:Italian Target Language: german send: Slide 1
Buongiorno, sono Gianluca Garbi, Amministratore Delegato di Banca Sistema.
Vorrei presentarvi il piano strategico di Banca Sistema per il periodo 2024-2026.
Slide 2
Prima di iniziare, a pagina 2, troverete l'ordine del giorno della presentazione, che include:
Una breve panoramica del nostro percorso di crescita dalla nascita del Gruppo.` })
    force_response.push({type:1, text: `Slide 1
Guten Morgen, ich bin Gianluca Garbi, CEO von Banca Sistema.
Ich möchte Ihnen den strategischen Plan von Banca Sistema für den Zeitraum 2024–2026 vorstellen.
Slide 2
Bevor wir beginnen, finden Sie auf Seite 2 die Agenda der Präsentation. Diese umfasst:
Einen kurzen Überblick über unseren Wachstumskurs seit der Gründung der Gruppe.`})

    for (let lang in voicesBody) {
      let selectedLang = voicesBody[lang]
      //start translation
      if (selectedLang.value === language){
        selectedLang.finalText = text
        console.log('')
        console.log('')
        console.log('------------------------- ****** ------------------------------')
        console.log('')
        console.log('')
        console.log('original text: ', text)
      } 
      else{
        const TRANSLAT_LANG = {'Italiano': 'italian', 'Inglese': 'english', 'Francese': 'french', 'Greco': 'greek', 'Portoghese': 'portuguese', 'Spagnolo':'spanish', 'Tedesco': 'german'}
        let send = `Original Language:${language} Target Language: ${TRANSLAT_LANG[selectedLang.text]} send: ${text}`
        const translater = await openaiSync(force_response, send, 'Translator')
        selectedLang.finalText = translater.text
        console.log('')
        console.log('')
        console.log('------------------------- ****** ------------------------------')
        console.log('')
        console.log('')
        console.log('translater text', translater.text)
        registerCost(0,'TEXT TRANSLATOR', userDetails?.id,translater.usage.total_tokens)
      }
      //finish translation

      let finalText = '';
      let initialText = '';
      
      //start pronunciation      
      
      const completion = await openaiAssistantAsync(PRONUNCIATION_ASSISTANT[selectedLang.text], selectedLang.finalText)
      for await (const chunk of completion) {
        if (chunk?.event === 'thread.message.delta') {
          if (finalText === '') {
            finalText = initialText + chunk.data.delta.content[0].text.value
          } else {
            finalText = finalText + chunk.data.delta.content[0].text.value
          }
          
        }
        if (chunk?.event === 'thread.run.completed') {
          await registerCost(0, 'CHAT STANDARD', userDetails?.id, chunk.data.usage.total_tokens)
        }
      }
      console.log('')
      console.log('')
      console.log('------------------------- ****** ------------------------------')
      console.log('')
      console.log('')
      console.log('pronunciation text', finalText)
      
      selectedLang.finalText = finalText
      

      //finish pronunciation

      finalText = '';
      initialText = '';

      let count = 5;
      while (count > 0){
        const completion2 = await openaiAssistantAsync('asst_4Z1xZi8tKec1S6tsSsMmOy7Q', selectedLang.finalText)
        for await (const chunk of completion2) {
          if (chunk?.event === 'thread.message.delta') {
            if (finalText === '') {
              finalText = initialText + chunk.data.delta.content[0].text.value
            } else {
              finalText = finalText + chunk.data.delta.content[0].text.value
            }
          }
          if (chunk?.event === 'thread.run.completed') {
            await registerCost(0, 'CHAT STANDARD', userDetails?.id, chunk.data.usage.total_tokens)
          }
        }
        selectedLang.finalText = finalText
        try{
          console.log('')
          console.log('')
          console.log('------------------------- ****** ------------------------------')
          console.log('')
          console.log('')
          console.log('slides list: ', finalText)
          finalText = JSON.parse(finalText)
          if (finalText.slides && finalText.slides.length > 0){
            finalText.slides = finalText.slides.map((slide)=>{return {...slide, language: slide.language === 'gl' ? 'el' : slide.language}})
            selectedLang.finalText = JSON.stringify(finalText)
            count = 0
          }
        }
        catch (error) {
          console.log('error', error)
        }
        count -= 1
      }

      

      

      
    }

    return voicesBody
  }

  

  const handleGenerateEdit = async () => {
    if (!slide?.id) {
      enqueueSnackbar({ variant: 'warning', message: 'Seleziona un progetto prima di generare il video' })
      return
    }

    setGenerating(true)

    try {
      const chosenSpeed = SPEED_VALUES[globalSpeedIdx] || 1
      const speedParam = chosenSpeed.toFixed(1)

      await axiosInstance.post(
        `${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects/${slide.id}/render_video?speedups=${speedParam}`
      )

      // refetch + reset + redireciona
      const res = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`)
      setAudioList(res.data.payload.video_projects)
      setSlide(null)
      setCurrentSlidEdit(null)
      setNewProject(null)
      history.push('/video-maker')

      // força status local para "running" até o backend atualizar
      setAudioList(prev =>
        prev.map(project =>
          project.id === slide.id ? { ...project, video_status: 'running', status: 'video_running' } : project
        )
      )

      enqueueSnackbar({ variant: 'success', message: 'Video messo in coda per la generazione' })
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: 'Errore interno, riprova più tardi' })
    } finally {
      setGenerating(false)
    }
  }

  const ensureSlidesCount = (slides, pages, languageCode, defaultVoice = 'Gianluca Garbi') => {
    DEBUG && console.group('[Slides] ensureSlidesCount')
    DEBUG && console.log('Entrou com:', { slidesCount: slides?.length || 0, pages, languageCode })

    if (!Array.isArray(slides)) slides = []
    const ordered = slides.slice().sort((a, b) => Number(a.slide_number) - Number(b.slide_number))

    if (!pages || pages <= 0) {
      DEBUG && console.log('Sem pages válidas. Retornando ordenado:', ordered.length)
      DEBUG && console.groupEnd()
      return ordered
    }

    if (ordered.length < pages) {
      const voice = (ordered.find(s => s?.voice)?.voice) || defaultVoice
      DEBUG && console.log(`Padding necessário: ${pages - ordered.length} slide(s)`)
      const start = ordered.length + 1
      for (let i = start; i <= pages; i++) {
        ordered.push({
          slide_number: i,
          text: 'empty',
          voice,
          pause: '2',
          language: languageCode
        })
      }
    } else {
      DEBUG && console.log('Padding não necessário.')
    }

    DEBUG && console.log('Resultado final de slides:', ordered.length)
    DEBUG && console.groupEnd()
    return ordered
  }



  const handleGenerate = async () => {
    setGenerating(true)
    try {
      const voicesBody = await asyncOpenAi()

      for (let voice in voicesBody) {
        const selectedVoice = voicesBody[voice]

        // 1) lê os slides do JSON
        let slides = []
        try {
          const parsed = JSON.parse(selectedVoice.finalText)
          slides = parsed?.slides || []
        } catch { slides = [] }
        DEBUG && console.group(`[Generate] ${selectedVoice.text} (${selectedVoice.value})`)
        DEBUG && console.log('Slides do JSON:', slides.length, 'Páginas do PDF:', pdfPages)

        // 2) se for vídeo e já sabemos as páginas do PDF, completa até pdfPages
        if (fileType === 1 && pdfPages) {
          const paddedSlides = ensureSlidesCount(slides, pdfPages, selectedVoice.value /*lang*/, /*defaultVoice*/ 'Gianluca Garbi')
          selectedVoice.finalText = JSON.stringify({ slides: paddedSlides })
          DEBUG && console.log('Slides após padding (se houve):', paddedSlides.length)
        }

        // 3) cria o projeto normalmente
        const body = {
          kind: fileType,
          name: `${nameOfTheProject} - ${selectedVoice.text}`,
          scripts_attributes: [{
            language: selectedVoice.value,
            content: selectedVoice.finalText
          }]
        }
        if (fileType === 1) {
          body['presentation_attributes'] = {
            data: await toBase64(files2[0]),
            filename: files2[0].name,
            content_type: files2[0].type
          }
        }

        const resCreate = await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`, body)
        const projectId = resCreate.data.payload.video_project.id

        // 4) se slides > páginas, mantém sua lógica atual (duplica/reordena imagens)
        //    pega novamente os slides que acabaram de ser salvos (já podem estar “padded”)
        let slidesNow = []
        try {
          slidesNow = JSON.parse(selectedVoice.finalText)?.slides || []
        } catch {}

        if (fileType === 1 && slidesNow.length > 0) {
          await rebuildPresentationImages(projectId, slidesNow)
        }

        // 5) gera o base
        await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects/${projectId}/generate_audio`)

        // 6) refetch lista
        const resList = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`)
        setAudioList(resList.data.payload.video_projects)
        DEBUG && console.groupEnd()
      }

      setFiles([]); setFiles2([]); setLanguage(''); setNameOfTheProject(''); setVoiceTarget([])
      await handleBack()
      enqueueSnackbar({ variant: 'success', message: 'File caricato correttamente' })
      setSlide(null)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setGenerating(false)
    }
  }


  const handleDownload = (fileUrl, filename) => {
    setDownloading(true)
    setDownloadDialogOpen(true)

    axiosInstance
      .get(normalizeFileUrl(fileUrl), { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data])
        const downloadUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = filename

        // Fecha o loading imediatamente antes de disparar o prompt/popup do navegador
        setDownloadDialogOpen(false)
        setDownloading(false)

        link.click()
        URL.revokeObjectURL(downloadUrl)
      })
      .catch(() => {
        setDownloadDialogOpen(false)
        setDownloading(false)
        enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
      })
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setVoiceTarget(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    )
  }

  const handleSort = (orderBy) => {
    setOrder(order === 'asc' ? 'desc' : 'asc')
    setOrderBy(orderBy)
    const sorded = audioList.sort((valueA, valueB) => {
      if (order === 'asc') {
        if (valueA[orderBy] < valueB[orderBy]) {
          return -1
        }
        if (valueA[orderBy] > valueB[orderBy]) {
          return 1
        }
        return 0
      }
      if (order === 'desc') {
        if (valueA[orderBy] > valueB[orderBy]) {
          return -1
        }
        if (valueA[orderBy] < valueB[orderBy]) {
          return 1
        }
        return 0
      }

    })
    setAudioList(sorded)
  }


  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElEdit, setAnchorElEdit] = useState(null);
  const [tooltipClip, setTooltipClip] = useState(null)


  const handleClosePopover = () => {
    setAnchorEl(null);
  }


  const handleClosePopoverEdit = () => {
    setShowSpeedSlider(false)
    setAnchorElEdit(null)
  }


  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const openEdit = Boolean(anchorElEdit)
  const idEdit = openEdit ? 'simple-popover' : undefined

  const handleDeleteFile = async () => {
    setDeletingFile(true)
    try {
      const deleteFile = await axiosInstance.delete(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects/${openDeleteModal}`)


      const results = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects`)
      setAudioList(results.data.payload.video_projects)
      setOpenDeleteModal(null)
      enqueueSnackbar({ variant: 'success', message: 'Progetto eliminato correttamente' })

    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setDeletingFile(false)
    }

  }

  const handleSetNewProject = async (project) => {
    // setLoading(true)
    // clona o projeto para não mutar o original
    const cloned = JSON.parse(JSON.stringify(project))

    // converte imagens da apresentação para data URL
    // if (cloned.presentation?.video_presentation_images?.length) {
    //   cloned.presentation.video_presentation_images = await Promise.all(
    //     cloned.presentation.video_presentation_images.map(async (img) => {
    //       try {
    //         const res = await axiosInstance.get(img.file_url, { responseType: 'blob' })
    //         const dataUrl = await toBase64(res.data) // retorna "data:image/jpeg;base64,...."
    //         return { ...img, file_url: dataUrl }
    //       } catch {
    //         return img // em erro, mantém o URL original
    //       }
    //     })
    //   )
    // }

    // usa direto os file_url que o backend já envia
    if (cloned.presentation?.video_presentation_images?.length) {
      console.log('[slides]', cloned.presentation.video_presentation_images.map(img => ({
        id: img.id,
        position: img.position,
        file_url: normalizeFileUrl(img.file_url)
      })))

      cloned.presentation.video_presentation_images = cloned.presentation.video_presentation_images.map(img => ({
        ...img,
        file_url: normalizeFileUrl(img.file_url) // já vem pronto da API
      }))
    }

    // converte áudios das seções para data URL (opcional, mas recomendado)
    if (cloned.scripts?.length) {
      cloned.scripts = cloned.scripts.map(script => ({
        ...script,
        audio: script.audio
          ? {
              ...script.audio,
              file_url: normalizeFileUrl(script.audio.file_url),
            }
          : script.audio,
        video_script_sections: script.video_script_sections.map(sec => ({
          ...sec,
          audio: {
            ...sec.audio,
            file_url: normalizeFileUrl(sec.audio.file_url)
          }
        }))
      }))
    }
    
    setNewProject(cloned)
    // setLoading(false)
    return cloned
  }

  const handleOpenModalEdit = (slide, type) => {
    if (type === 'presentation') {
      setOpenEditModal(true)
      setType(2)
    } else {
      setType(1)
      setOpenEditModal(true)
      setNewTextAudio(slide.audio.text)
    }

  }

  const handleSaveEdit = async (typeX) => {
    setSavingNewAudio(true)

    if (!slide?.scripts?.[0]?.video_script_sections) {
      setSavingNewAudio(false)
      return
    }

    try {
      if (typeX === 1) {
        const sectionId = currentSlidEdit?.sectionId || currentSlidEdit?.audio?.origin_id
        if (!sectionId) {
          enqueueSnackbar({ variant: 'error', message: 'Section ID non trovato' })
          return
        }

        addRegenerating(sectionId)

        await axiosInstance.patch(`${API_URL}/video_script_sections/${sectionId}`, { text: newTextAudio })
        setOpenEditModal(false)

        await axiosInstance.post(`${API_URL}/video_script_sections/${sectionId}/generate`)
        
        try {
          await waitForSectionAudio(sectionId, API_URL)
          await reloadCurrentProject(API_URL)
          enqueueSnackbar({
            variant: 'success',
            message: `Audio della slide ${currentSlidEdit.position} rigenerato con successo`
          })
        } catch (err) {
          // enqueueSnackbar({
          //   variant: 'warning',
          //   message: 'Audio inviato per rigenerazione, aggiorna più tardi se non vedi il risultato'
          // })
        }
        return
      }

      const file = files3[0]
      if (!file) {
        enqueueSnackbar({ variant: 'warning', message: 'Seleziona un file immagine' })
        return
      }

      const previewUrl = URL.createObjectURL(file)

      setSlide(prev => {
        if (!prev) return prev
        return {
          ...prev,
          presentation: {
            ...prev.presentation,
            video_presentation_images: prev.presentation.video_presentation_images.map(img =>
              img.id === currentSlidEdit.presentation.id
                ? { ...img, file_url: previewUrl }
                : img
            )
          }
        }
      })

      const payload = {
        data: await toBase64(file),
        filename: file.name,
        content_type: file.type,
      }

      await axiosInstance.patch(
        `${API_URL}/video_presentation_images/${currentSlidEdit.presentation.id}`,
        payload
      )

      setListEditedSlides(prev => [...prev, currentSlidEdit.position])
      enqueueSnackbar({ variant: 'success', message: 'Slide sostituita correttamente' })
      setFiles3([])
      setOpenEditModal(false)
    } catch (error) {
      console.error(error)
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setSavingNewAudio(false)
    }
  }


  //-------------------------------------------- Imagens da apresentação --------------------------------------------
  const waitForProjectWithImages = async (projectId, { timeoutMs = 90000, intervalMs = 1200 } = {}) => {
    const start = Date.now()
    while (Date.now() - start < timeoutMs) {
      const res = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_projects/${projectId}`)
      const proj = res.data.payload.video_project
      const imgs = proj?.presentation?.video_presentation_images || []
      if (imgs.length > 0) return proj
      await new Promise(r => setTimeout(r, intervalMs))
    }
    throw new Error('Timeout while waiting for presentation images extraction')
  }

  // baixa uma imagem e retorna dataURL
  const downloadImageAsDataUrl = async (url) => {
    const resp = await axiosInstance.get(url, { responseType: 'blob' })
    return await toBase64(resp.data)
  }

  /// reconstroi TODAS as imagens da apresentação na ordem desejada (uma por section)
  const rebuildPresentationImages = async (projectId, slides) => {
    DEBUG && console.group('[Images] rebuildPresentationImages')
    DEBUG && console.log('Projeto:', projectId, 'Slides JSON:', slides.length)

    const project = await waitForProjectWithImages(projectId)

    const presentationId = project?.presentation?.id
    const original = (project.presentation.video_presentation_images || [])
      .slice()
      .sort((a, b) => (a.position || 0) - (b.position || 0))

    DEBUG && console.log('Imagens extraídas do PDF:', original.length, 'presentationId:', presentationId)

    const orderedSlides = (slides || [])
      .slice()
      .sort((a, b) => Number(a.slide_number) - Number(b.slide_number))

    if (original.length === orderedSlides.length) {
      const looksOK = original.every((img, idx) => {
        const desiredSrc = Math.max(1, Number(orderedSlides[idx].slide_number) || 1)
        const m = /__src_(\d+)\./.exec(img.filename || '')
        return m ? Number(m[1]) === desiredSrc : false
      })
      if (looksOK) {
        DEBUG && console.log('Pulando rebuild: contagem e mapeamento já corretos.')
        DEBUG && console.groupEnd()
        return
      } else {
        DEBUG && console.log('Contagem bate, mas marcador não confere. Rebuild necessário.')
      }
    } else {
      DEBUG && console.log('Rebuild necessário. Contagem diferente:', {
        imagens: original.length,
        slides: orderedSlides.length
      })
    }

    const imgCache = new Map()
    const defaultContentType = 'image/jpeg'
    const desiredImages = []
    const totalPages = original.length
    for (const s of orderedSlides) {
      const nRaw = Number(s.slide_number) || 1
      // A) clamp na última página 
      const n = Math.min(Math.max(1, nRaw), totalPages)
      const baseImg = original[n - 1]
      if (!baseImg) {
        DEBUG && console.error(`Base image não encontrada para slide_number=${n}`)
        throw new Error(`Imagem base para slide_number=${n} não encontrada`)
      }
      if (!imgCache.has(n)) {
        const dataUrl = await downloadImageAsDataUrl(baseImg.file_url)
        imgCache.set(n, { dataUrl, filename: baseImg.filename || `slide_${n}.jpg`, contentType: defaultContentType })
      }
      DEBUG && console.log(`Mapeando slide_number=${nRaw} -> pagina=${n}`)
      desiredImages.push(imgCache.get(n))
    }
    DEBUG && console.log('Desejado (imagens):', desiredImages.length)

    // Delete atual
    DEBUG && console.log('Deletando imagens atuais...')
    for (const img of original) {
      try {
        await axiosInstance.delete(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_presentation_images/${img.id}`)
      } catch (e) {
        DEBUG && console.warn('Falha ao deletar imagem id=', img.id, e?.message)
      }
    }

    // Cria na ordem
    DEBUG && console.log('Criando imagens na ordem desejada...')
    for (let i = 0; i < desiredImages.length; i++) {
      const item = desiredImages[i]
      const desiredSrc = Math.max(1, Number(orderedSlides[i].slide_number) || 1)
      const body = {
        video_presentation_image: {
          video_presentation_id: presentationId,
          position: i + 1,
          data: item.dataUrl,
          filename: `slide_${i + 1}__src_${desiredSrc}.jpg`,
          content_type: item.contentType || 'image/jpeg'
        }
      }
      DEBUG && console.log(`POST imagem pos=${i + 1}, srcBase=${desiredSrc}`)
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/video_presentation_images`, body)
    }

    DEBUG && console.log('Rebuild finalizado.')
    DEBUG && console.groupEnd()
  }


  if (projectsLoading || userLoading) {
    return (
      <AppBar>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Box style={{ position:'absolute', top:'50%', left:'50%' }}>
            <CircularProgress />
          </Box>
        </main>
      </AppBar>
    )
  }

  return (
    <AppBar>
      {(!userDetails?.enable_video_maker) ?  
        <Box id="coming-soon" style={{ 
          background: 'white',
          backgroundImage: `url(${forbidden})`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', width: '100%' }} 
      /> 
      :
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <>
          <Typography className={classes.title} style={{ float: 'left' }} variant="h5" gutterBottom component="h2">
            {(fileType === 2 && view === 2) ? 'Audio Maker' : 'Video Maker'}
          </Typography>

          {(projectsLoading || userLoading) ?
            <Box>
              <CircularProgress style={{ position: 'absolute', top: '50%', left: '50%' }} size={50} />
            </Box> :
            <>
              <Box style={{ float: 'right' }}>

                {view === 1 && !slide && <Box style={{display:'flex' ,flexDirection:'row', justifyContent:'space-around', marginBottom:'1rem'}}>
                  
                  <Button
                    onClick={() => {
                      setView(2);
                      setFileType(2);
                    }}
                    variant="outlined"
                    style={{
                      marginRight: '1rem',
                      width: '11rem',
                      borderColor: hovered === 'mp3' ? customTheme.colors.ui.red : 'rgba(0, 0, 0, 0.23)',
                      // color: hovered === 'mp3' ? 'red' : 'inherit',
                      transition: 'border-color 0.3s, color 0.3s',
                    }}
                    onMouseEnter={() => setHovered('mp3')}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Nuovo MP3
                  </Button>

                  <Button
                    onClick={() => {
                      setView(2);
                      setFileType(1);
                    }}
                    variant="outlined"
                    style={{
                      width: '11rem',
                      borderColor: hovered === 'video' ? customTheme.colors.ui.red : 'rgba(0, 0, 0, 0.23)',
                      // color: hovered === 'video' ? 'red' : 'inherit',
                      transition: 'border-color 0.3s, color 0.3s',
                    }}
                    onMouseEnter={() => setHovered('video')}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Nuovo Video
                  </Button>

                </Box>}
                <Box style={{ display: 'flex', flexDirection: 'row', }}>
                  {(voiceTarget.length > 0 || language || files.length > 0 || files2.length > 0 || nameOfTheProject) &&
                    <Box onClick={() => {
                      setNameOfTheProject('')
                      setFiles2([])
                      setFiles([])
                      setLanguage('')
                      setVoiceTarget([])


                    }} style={{ color: customTheme.colors.ui.red, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}><img style={{ position: 'relative', top: '0.3rem' }} src={iconClean} /> Pulisci</Box>
                  }

                  {(view === 2 || slide) && <Box onClick={() => {
                    setSlide(null)
                    setView(1)
                    setNameOfTheProject('')
                    setFiles2([])
                    setFiles([])
                    setLanguage('')
                    setVoiceTarget([])
                    history.push(`/video-maker/${projectId}`)
                  }} style={{ textDecoration: 'underline', marginRight: '1rem', cursor: 'pointer', fontSize: '1rem' }}>Torna indietro</Box>}

                </Box>
                
                {savedAudioModalOpen &&
                  <AppBarHistory style={{ marginTop: '4rem', backgroundColor: 'white', width: '60vw', height: '100%' }}>
                    <Box style={{ padding: '20px', cursor: 'pointer' }}>
                      <Box style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
                        <ArrowForwardIosIcon onClick={() => setSavedAudioModalOpen(false)} style={{ color: 'black' }} />
                        <Typography style={{ color: 'black', marginLeft: '1rem' }} variant='h6'>Archivio</Typography>
                      </Box>
                      <ul style={{ listStyleType: 'none', lineHeight: 2 }}>
                        {savedAudio.map((audio) => {
                          return <Box style={{
                            width: '100%',
                            backgroundColor: 'white',
                            padding: '1rem',
                            borderRadius: 15,
                            marginBottom: '1rem',
                            boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
                            color: 'black', fontSize: '1rem', display: 'grid',
                            gridTemplateColumns: '1.6fr 1.6fr 1.6fr 1.3fr',
                            gap: '1.5rem'
                          }} key={audio.id}>
                            <Box><InsertDriveFileIcon style={{ color: 'grey', fontSize: '1.1rem', position: 'relative', top: '0.1rem', marginRight: '0.5rem' }} />{audio.source_document.filename}</Box>
                            <Box style={{ fontSize: '0.9rem', textAlign: 'right' }}>{moment(audio.created_at).format('dd MM YYYY hh:mm')}</Box>
                            <Box style={{ display: 'flex', flexDirection: 'row' }}>
                              <Box style={{
                                marginRight: '0.5rem',
                                width: 22,
                                height: 22,
                                borderRadius: '50%',         
                                display: 'inline-flex',       
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
                                color: 'white',
                                lineHeight: 1,                
                                textTransform: 'uppercase',  
                                }}>{userDetails?.first_name.slice(0, 1)}
                              </Box>
                            {userDetails?.first_name} {userDetails?.last_name}</Box>
                            <Box style={{ textAlign: 'center' }}><img style={{ width: '1rem', marginRight: '0.8rem' }} src={condividiSvg} /><DownloadIcon style={{ color: 'grey', fontSize: '1.2rem', position: 'relative', top: '0.1rem' }} /></Box>
                          </Box>
                        })}
                      </ul>

                    </Box>
                  </AppBarHistory>
                }
              </Box>

              <TableContainer>
                <Divider />

                <Dialog open={downloadDialogOpen} onClose={() => {}} PaperProps={{ style: { borderRadius: 15 } }}>
                  <Box style={{ padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 260 }}>
                    <CircularProgress />
                    <Typography style={{ marginTop: '1rem' }}>Preparando il download...</Typography>
                  </Box>
                </Dialog>

                {openNewProject &&
                  <Dialog onClose={() => setOpenNewProject(false)} open={openNewProject} fullWidth maxWidth="md" >
                    <Box style={{ padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                      <Typography style={{ marginBottom: '1rem' }} variant='h5'>Crea nuovo progetto</Typography>
                      <Divider />
                      <Box style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center' }}>
                        <TextField fullWidth variant='outlined' style={{ width: '60%', marginTop: '1.5rem', marginRight: '1rem' }} placeholder='Nome del progetto' value={nameOfTheProject} onChange={(event) => setNameOfTheProject(event.target.value)} />
                        <Box onClick={() => {
                          setOpenNewProject(false)
                          setFileType(2)
                          setView(2)
                        }} style={{ cursor: 'pointer', fontSize: '0.9rem', padding: '1rem 0', width: '20%', marginTop: '1.5rem', height: '3.5rem', borderRadius: 15, boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`, marginRight: '1rem' }}>Mp3</Box>
                        <Box onClick={() => {
                          setOpenNewProject(false)
                          setFileType(1)
                          setView(2)
                        }} style={{ cursor: 'pointer', fontSize: '0.9rem', padding: '1rem 0', width: '20%', marginTop: '1.5rem', height: '3.5rem', borderRadius: 15, boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`, marginRight: '1rem' }}>Video</Box>

                      </Box>
                      <FormControl className={classes.formControl} style={{ marginTop: '1.5rem' }}>

                        <InputLabel onClick={(event) => handleClickLanguage(event)} className={classes.input} id="demo-simple-select-label"><Box style={{ top: '0.2rem', position: 'relative', }}>Carica audio o seleziona dall'archivio</Box></InputLabel>
                        <Select

                          placeholder="Carica video o seleziona dall'archivio"
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                          }}
                          label={
                            <Box>Carica audio o seleziona dall'archivio</Box>
                          }
                          variant='outlined'
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={''}
                        >
                          {filesUploaded.map(({ text, value }) => {
                            return <MenuItem key={value} value={value}>
                              {text}
                            </MenuItem>
                          })}

                        </Select>
                      </FormControl>

                      <FormControl className={classes.formControl} style={{ marginTop: '1.5rem' }}>

                        <InputLabel onClick={(event) => handleClickLanguage(event)} className={classes.input} id="demo-simple-select-label"><Box style={{ top: '0.2rem', position: 'relative', }}>Carica video o seleziona dall'archivio</Box></InputLabel>
                        <Select

                          placeholder="Carica video o seleziona dall'archivio"
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                          }}
                          label={
                            <Box>Carica video o seleziona dall'archivio</Box>
                          }
                          variant='outlined'
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={''}
                        >
                          {filesUploaded.map(({ text, value }) => {
                            return <MenuItem key={value} value={value}>
                              {text}
                            </MenuItem>
                          })}

                        </Select>
                      </FormControl>

                      <Box style={{ marginTop: '1.5rem' }}>
                        <Button onClick={() => setOpenNewProject(false)} variant='contained' style={{ marginRight: '1rem' }} >Annulla</Button>
                        <Button color='primary' variant='contained'  >Crea</Button>
                      </Box>

                    </Box>
                  </Dialog>
                }

                {openEditModal &&
                  <Dialog onClose={() => {
                    setFiles3([])
                    setOpenEditModal(false)
                  }} open={openEditModal} fullWidth maxWidth="md" >
                    <Box style={{ padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <Typography style={{ marginBottom: '1rem', float:'left' }} variant="h5">
                      {type === 2 ? 'Sostituisci slide' : 'Modifica il contenuto audio'}
                      </Typography>
                      <Divider width={'100%'}/>

                      <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        {type === 1 ? (
                          <textarea
                            variant="outlined"
                            style={{ resize: 'none', width: '100%', height: '25vh', marginTop: '1.5rem', padding: '1rem', fontSize: '.9rem', borderRadius: 15, border: `1px solid ${customTheme.colors.ui.grey}` }}
                            value={newTextAudio}
                            onChange={event => setNewTextAudio(event.target.value)}
                          />
                        ) : (
                          <FormControl className={classes.formControl} style={{ flex: 1, marginRight: 0 }}>
                            <Box
                              onClick={handleClickFileUpload3}
                              style={{
                                width: '100%',
                                marginTop: '1rem',
                                padding: '1.2rem',
                                borderRadius: 15,
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <InsertDriveFileIcon style={{ position: 'relative', marginRight: 8 }} />
                              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {files3.length ? files3[0].name : `Carica slide (${ACCEPTED_IMAGE_LABEL})`}
                              </span>
                            </Box>

                            <input
                              style={{ display: 'none' }}
                              accept={[...ACCEPTED_IMAGE_MIME, ...ACCEPTED_IMAGE_EXT].join(',')}
                              ref={inputRef3}
                              type="file"
                              hidden
                              onClick={e => { e.target.value = null }}
                              onChange={handleFileUpload3}
                            />
                          </FormControl>
                        )}
                      </Box>

                      <Box style={{ marginTop: '1.5rem', width: '100%', textAlign: 'center' }}>
                        <Button
                          disabled={savingNewAudio}
                          onClick={() => {
                            setFiles3([])
                            setOpenEditModal(false)
                          }}
                          variant="contained"
                          style={{ width: '8vw', marginRight: '1rem' }}
                        >
                          Annulla
                        </Button>
                        <Button disabled={savingNewAudio || (type === 2 && files3.length === 0)} onClick={() => handleSaveEdit(type)} style={{ width: '8vw' }} color="primary" variant="contained">
                          {savingNewAudio ? <CircularProgress color="secondary" size={22} /> : 'Salva'}
                        </Button>
                      </Box>
                    </Box>
                  </Dialog>
                }

                <Box style={{display:'flex', justifyContent:'space-between', paddingRight:'1.5rem', margin: '1.5rem 0'}}>
                  {slide?.name &&
                    <Box style={{ }}>
                      <Typography style={{fontSize:'1.1rem',}}>{slide.name}</Typography>
                    </Box> 
                  }

                  {slide && slide.kind === 1 && (
                    <Box style={{ padding: 1, minWidth: '20vw' }}>
                      <Typography gutterBottom align="right">
                        Velocità del video
                      </Typography>
                      <Slider
                        value={globalSpeedIdx}
                        onChange={(e, value) => setGlobalSpeedIdx(value)}
                        step={1}
                        min={0}
                        max={SPEED_VALUES.length - 1}
                        marks={SPEED_MARKS}
                        valueLabelDisplay="auto"
                        valueLabelFormat={val => SPEED_MARKS[val].label}
                      />
                    </Box>
                  )}
                </Box>


                {view === 2 ?
                  <Box>
                    <FormControl className={classes.formControl} style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', 
                        // borderRadius: 15, border: `1px solid ${customTheme.colors.ui.greyLight}`, padding: '1rem 1rem 2rem 1rem' 
                      }} >
                      <Typography style={{ marginBottom: '0rem', paddingLeft:'1rem' }}>{(fileType === 2 && view === 2) ? "Imposta l'audio del tuo nuovo progetto" : "Imposta il tuo nuovo video"}</Typography>
                      <Box style={{ display: 'flex', flexDirection: 'row', flex:1, gap:'1rem'}}>
                        <FormControl style={{width:'100%'}}>
                          <TextField onChange={(event) => setNameOfTheProject(event.target.value)} value={nameOfTheProject} placeholder='Nome del progetto' style={{ marginTop: '1.1rem' }} variant='outlined' />
                        </FormControl>
                        <FormControl style={{ minWidth:'350px'}}>

                          <InputLabel onClick={(event) => handleClickStyleImage(event)} className={classes.input} id="demo-simple-select-label"><Box style={{ color: (textarea && !language) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua originale</Box></InputLabel>
                          <Select
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                              },
                              getContentAnchorEl: null
                            }}
                            label={
                              <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua originale</Box>
                            }
                            variant='outlined'
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={language}
                            onChange={(event) => { {
                              //setVoiceTarget(event.target.value)
                              setLanguage(event.target.value) 
                            }}}
                          >
                            {languages.map(({ text, value }) => {
                              return <MenuItem key={value} value={value}>
                                {text}
                              </MenuItem>
                            })}

                          </Select>
                        </FormControl>
                        {<FormControl style={{ minWidth:'350px'}}>
                          <InputLabel onClick={(event) => handleClickStyleImage(event)} className={classes.input} id="demo-multiple-checkbox-label"><Box style={{ color: (textarea && !voiceTarget) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua/e target</Box></InputLabel>
                          <Select
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                              },
                              getContentAnchorEl: null
                            }}
                            label={
                              <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua/e target</Box>
                            }
                            multiple
                            variant='outlined'
                            labelId="demo-multiple-checkbox-label"
                            id="demo-simple-select"
                            renderValue={(selected) => selected.join(', ')}
                            value={voiceTarget}
                            onChange={handleChange}
                          >
                            {languages.map(({ text }) => {
                              return <MenuItem key={text} value={text}>
                                <Checkbox color='primary' checked={voiceTarget.includes(text)} />
                                <ListItemText primary={text} />
                              </MenuItem>
                            })}

                          </Select>
                        </FormControl> }
                        {/*
                        <FormControl className={classes.formControl}>
                          <InputLabel onClick={(event) => handleClickStyleImage(event)} className={classes.input} id="demo-multiple-checkbox-label"><Box style={{ color: (textarea && !voiceTarget) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua/e target</Box></InputLabel>
                          <Select
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                              },
                              getContentAnchorEl: null
                            }}
                            label={
                              <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={languageTargetIcon} />Lingua/e target</Box>
                            }
                            disabled={true}
                            variant='outlined'
                            labelId="demo-multiple-checkbox-label"
                            id="demo-simple-select"
                            value={voiceTarget}
                            onChange={(event) => { setLanguage(event.target.value) }}
                          >
                            {languages.filter(({value}) => value === language).map(({ text, value }) => {
                              return <MenuItem value={value}>
                                {text}
                              </MenuItem>
                            })}

                          </Select>
                        </FormControl>
                        */}
                        

                      </Box>
                      <FormControl style={{ width: '100%' }}>

                        <ListItemText onClick={handleClickFileUpload} style={{ color: '#3262BB', width: '100%', marginTop: '1rem', padding: '1rem', borderRadius: 15, border: `1px solid rgba(0, 0, 0, 0.23)`, textDecoration: 'underline', cursor: 'pointer' }}><img style={{ color: '#3262BB', top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconWord} />{files.length ? files[0].name : 'Carica il tuo file Word con le istruzioni oppure transcinalo direttamente qui'}
                          <AddIcon style={{ color: customTheme.colors.ui.red, fontSize: '1.5rem', float:'right' }} />
                        </ListItemText>
                        <input multiple="multiple" style={{ display: 'none' }} accept={".docx, .doc"} ref={inputRef} type='file' hidden onClick={(event) => {
                          event.target.value = null
                        }} onChange={handleFileUpload} />
                      </FormControl>
                      {fileType === 1 && <FormControl style={{ width: '100%' }}>

                          <ListItemText onClick={handleClickFileUpload2} style={{ color: '#B91F26', width: '100%', marginTop: '1rem', padding: '1rem', borderRadius: 15, border: `1px solid rgba(0, 0, 0, 0.23)`, textDecoration: 'underline', cursor: 'pointer' }}><img style={{ color: '#B04327', top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconPdf} />{files2.length ? files2[0].name : 'Carica la tua presentazione PDF oppure transcinala direttamente qui'}
                            <AddIcon style={{ color: customTheme.colors.ui.red, fontSize: '1.5rem', float:'right' }} />
                          </ListItemText>
                          <input multiple="multiple" style={{ display: 'none' }} accept={".pdf"} ref={inputRef2} type='file' hidden onClick={(event) => {
                            event.target.value = null
                          }} onChange={handleFileUpload2} />
                        </FormControl>
                      }
                    </FormControl>
                    <Box
                      style={{
                        width: '100%', marginTop: '1rem', display: 'grid',
                        gridTemplateColumns: '1fr',
                        gap: '1rem',

                      }}>
                      <Box style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                      }}>

                        <Box style={{

                        }}>

                          <Box style={{ width: '100%', textAlign: 'center' }}>
                            <Button color="primary" style={{ width: '8rem', }} disabled={generating || !files.length || (!files2.length && fileType === 1) || !nameOfTheProject || !language || !voiceTarget.length} onClick={() => handleGenerate()} variant='contained'>{generating ? <CircularProgress color='secondary' size={22} /> : 'Genera'}</Button>
                          </Box>
                        </Box>

                      </Box>


                    </Box>

                  </Box>
                  : false ? <Box>
                    <MoreVertIcon />
                    <AudioPlayer newProject={newProject} />
                  </Box>
                    : 
                    <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', marginTop: '1rem', gap: 25 }}>

                      {newProject && !slide && (
                        <Box
                          // onClick={handleBack}
                          onClick={() => {
                            setNewProject(false)
                            history.push('/video-maker')
                          }}
                          style={{
                            cursor: 'pointer',
                            height: '18vh',
                            padding: '1rem',
                            textAlign: 'center',
                            backgroundColor: customTheme.colors.ui.greyLight,
                            borderRadius: 15
                          }}
                        >
                          <Box style={{ position: 'relative', top: '25%' }}>
                            <ArrowBackIosIcon style={{ fontSize: '1.8rem', color: customTheme.colors.ui.red, marginBottom: '1rem' }} />
                            <Typography>Torna indietro</Typography>
                          </Box>
                        </Box>
                      )}

                      {slide
                        ? slide?.scripts[0]?.video_script_sections.map((scr, index) => {
                            // Slides
                            const presentation = slide?.presentation?.video_presentation_images[index]
                            const audioFileUrl = slide.scripts[0].video_script_sections[index]?.audio?.file_url
                            const sourceNumber = getSourceSlideNumber(presentation);
                            const label = sourceNumber ?? scr.position;
                            const sectionId = scr.id
                            const isRegenerating = regeneratingSections.has(sectionId)
                            const url = normalizeFileUrl(presentation?.file_url)
                            console.log('img src ->', url)

                            return (
                              <Box key={`section-${scr.id}`} style={{ textAlign: 'center' }}>
                                <Typography
                                  style={{
                                    color: listEditedSlides.includes(scr.position) ? customTheme.colors.ui.red : customTheme.colors.ui.greyDark,
                                    marginBottom: '0.5rem'
                                  }}
                                >
                                  {`Slide ${label}`}
                                </Typography>

                                <Box
                                  style={{
                                    border: `${listEditedSlides.includes(scr.position) ? '3px' : '1px'} solid ${customTheme.colors.ui.red}`,
                                    height: '16vh',
                                    textAlign: 'center',
                                    borderRadius: 15,
                                    position: 'relative',
                                    overflow: 'hidden',
                                    opacity: isRegenerating ? 0.5 : 1,
                                    pointerEvents: isRegenerating ? 'none' : 'auto'
                                  }}
                                >
                                  <img
                                    src={url}
                                    alt=""
                                    onLoad={() => setLoadedImages(prev => ({ ...prev, [presentation?.id]: true }))}
                                    onError={() => setLoadedImages(prev => ({ ...prev, [presentation?.id]: true }))} // evita spinner infinito em erro
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      display: 'block' // remove gaps de inline-img
                                    }}
                                  />

                                  {!loadedImages[presentation?.id] && slide?.kind === 1 && (
                                    <Box
                                      style={{
                                        position: 'absolute',
                                        inset: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: 'rgba(255,255,255,0.6)'
                                      }}
                                    >
                                      <CircularProgress size={24} />
                                    </Box>
                                  )}

                                  {isRegenerating && (
                                    <Box
                                      style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: 'rgba(255,255,255,0.7)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        padding: '1rem'
                                      }}
                                    >
                                      <CircularProgress size={24} />
                                      <Typography variant="body2" style={{ marginTop: '0.5rem' }}>
                                        Rigenerando audio...
                                      </Typography>
                                    </Box>
                                  )}

                                  {slide?.kind === 1 && (
                                    <Box
                                      onClick={() => {
                                        setCurrentSlidEdit({
                                          position: scr.position,
                                          id: slide.id,
                                          presentation,
                                          audio: slide.scripts[0].video_script_sections[index],
                                          sectionId: scr.id
                                        })
                                        handleOpenModalEdit(
                                          { presentation, audio: slide.scripts[0].video_script_sections[index] },
                                          'presentation'
                                        )
                                      }}
                                      title="Sostituisci slide"
                                      style={{
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        cursor: 'pointer',
                                        background: 'white',
                                        borderRadius: 15,
                                        padding: 5,
                                        boxShadow: '0 0 6px rgba(0,0,0,.2)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: `1px solid ${customTheme.colors.ui.red}`
                                      }}
                                    >
                                      <CachedIcon style={{ fontSize: '1.2rem', color: customTheme.colors.ui.red, fontWeight: 'bold' }} />
                                    </Box>
                                  )}
                                </Box>


                                

                                {audioFileUrl ? (
                                  <AudioPlayer
                                    isRegenerating={isRegenerating}
                                    handleOpenPopover={(event) => {
                                      setCurrentSlidEdit({ position: scr.position, id: slide.id, presentation, audio: slide.scripts[0].video_script_sections[index], sectionId: scr.id  })
                                      setCurrentPopoverEdit({ presentation, audio: slide.scripts[0].video_script_sections[index] })
                                      setAnchorElEdit(event.currentTarget)
                                    }}
                                    audioSrc={normalizeFileUrl(audioFileUrl)}
                                    playbackRate={sectionRates[scr.id] || 1}
                                  />
                                ) : (
                                  <Box style={{ display: 'flex', justifyContent: 'center', padding: '0.5rem 0' }}>
                                    <CircularProgress size={24} />
                                  </Box>
                                )}
                              </Box>
                            )
                          })
                        : newProject
                        ? newProject.scripts.map((script) => {
                            return (
                              <Box key={`script-${script.language}`}>
                                <Box
                                  onClick={() => {
                                    setSlide(newProject)
                                    history.push(`/video-maker/${newProject.id}/edit`)
                                  }}
                                  style={{ backgroundColor: customTheme.colors.ui.greyLight, cursor: 'pointer', height: '18vh', padding: '1rem', textAlign: 'center', borderRadius: 15 }}
                                >
                                  <Box style={{ position: 'relative', top: '30%' }}>
                                    <img src={newProject.kind === 1 ? videoSvg : mp3svg} alt="" />
                                  </Box>
                                </Box>
                                <Box style={{ marginTop: '0.5rem' }}>
                                  <Box aria-describedby={newProject.id} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography style={{ fontSize: '0.9rem' }}>
                                      {newProject.name} - {script.language}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            )
                          })
                        : audioList.map((audio) => {
                            const audioHasFile = (audio.scripts || [])
                              .some(script => script.audio?.file_url);
                            const isVideoRendering = audio.video_status === 'running' || audio.status === 'video_running'
                            const videoFailed       = audio.video_status === 'error'   || audio.status === 'video_error'
                            const hasLegacyAudio = (audio.scripts || []).some(script =>
                              (script.video_script_sections || []).some(section => section.audio?.file_url)
                            )
                            const canOpenProject = (project) => {
                              if (project.video_status === 'running' || project.status === 'video_running') return false
                              if (project.kind === 2) {
                                return project.audio_status === 'done' && audioHasFile;
                              }
                              if (project.audio_status === 'done') return true
                              if (hasLegacyAudio) return true   // libera projetos antigos

                              return false
                            }
                            const canOpen = canOpenProject(audio)
                            
                            
                            const audioStatusLabel = (() => {
                              if (isVideoRendering) return 'Video in corso…'
                              if (videoFailed) return 'Video non riuscito'

                              if (audio.audio_status === 'done') return 'Audio pronto'
                              if (audio.audio_status === 'running') return 'Audio in creazione…'

                              if (audio.kind === 2) {
                                if (audio.audio_status === 'pending' || audio.audio_status === 'running')
                                  return 'Audio in creazione…';
                                if (audio.audio_status === 'done' && audioHasFile)
                                  return 'Audio pronto';
                                if (audio.audio_status === 'done' && !audioHasFile)
                                  return 'Audio disponibile presto';
                                return 'Audio non generato';
                              }
                              if (hasLegacyAudio) return 'Audio disponibile (storico)'

                              return 'Audio non generato'
                            })()


                            return (
                              <Box key={audio.id}>
                                <Box
                                  onClick={() => {
                                    if (canOpenProject(audio)) {
                                      handleSetNewProject(audio)
                                      history.push(`/video-maker/${audio.id}`)
                                    }
                                  }}
                                  style={{
                                    // opacity: ['pending', 'running', 'error'].includes(audio.status) && '0.6',
                                    // pointerEvents: ['pending', 'running', 'error'].includes(audio.status) && 'none',
                                    opacity: !canOpenProject(audio) ? 0.5 : 1,
                                    pointerEvents: !canOpenProject(audio) ? 'none' : 'auto',
                                    backgroundColor: customTheme.colors.ui.greyLight,
                                    cursor: 'pointer',
                                    height: '18vh',
                                    padding: '1rem',
                                    textAlign: 'center',
                                    borderRadius: 15
                                  }}
                                >
                                  <Box style={{ position: 'relative', top: '30%' }}>
                                    <img src={audio.kind === 1 ? videoSvg : mp3svg} alt="" />
                                    <Typography style={{ color: videoFailed ? '#B91F26' : '#666', fontSize: '0.8rem' }}>
                                      {audioStatusLabel}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box style={{ marginTop: '0.5rem' }}>
                                  <Box aria-describedby={audio.id} style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Box>
                                      <Typography style={{ fontSize: '1rem', float: 'left', width: '70%' }}>{audio.name}</Typography>
                                      <Box style={{ float: 'right' }}>
                                        {audio.status === 'done' && (
                                          <DownloadIcon
                                            style={{ cursor: 'pointer', marginRight: '0.5rem' }}
                                            onClick={(event) => {
                                              setCurrentPopover(audio)
                                              setAnchorEl(event.currentTarget)
                                            }}
                                          />
                                        )}
                                        <DeleteForeverIcon onClick={() => setOpenDeleteModal(audio.id)} style={{ cursor: 'pointer', float: 'right', color: customTheme.colors.ui.red }} />
                                      </Box>
                                    </Box>
                                  </Box>

                                  <Box style={{ fontSize: '0.8rem', color: customTheme.colors.ui.greyDark }}>{moment(audio.created_at).format('DD/MM/YYYY hh:mm')}</Box>
                                </Box>
                              </Box>
                            )
                          })}

                    </Box>
                }

                {openDeleteModal &&
                  <Dialog onClose={() => setOpenDeleteModal(null)} open={Boolean(openDeleteModal)}>
                    <Box style={{ minWidth: 450, padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                      <Typography variant='h5'>Conferma richiesta</Typography>
                      <Typography style={{ marginTop: '1rem', fontSize: '0.9rem' }}>Vuoi davvero eliminare questo file?</Typography>
                      <Typography style={{ fontSize: '0.9rem' }}>Una volta eliminato, non sarà possibile recuperarlo.</Typography>
                      <Box style={{ marginTop: '1.5rem' }}>
                        <Button color='primary' onClick={() => handleDeleteFile()} variant='contained'>{deletingFile ? <CircularProgress color='secondary' size={22} /> : 'Elimina'}</Button>
                      </Box>

                    </Box>
                  </Dialog>
                }
                {currentPopover && <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClosePopover}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <Box style={{ padding: '1.2rem 1.2rem 1.2rem 1.2rem' }}>
                    <span style={{ fontWeight: 'bold', }}>Scarica:</span>
                    <Box style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', lineHeight: 2.2, marginTop: '0.5rem' }}>
                      {currentPopover.scripts.map((script) => {
                        const videosReuced = script.videos.reduce((acc, value) => {
                          acc[value.speedup] = value
                          return acc
                        }, {})
                        if (currentPopover.kind === 2) {
                          const langLabel =
                            languages.find(({ value }) => value === script.language)?.text ||
                            script.language.toUpperCase();

                          if (!script.audio?.file_url) {
                            return (
                              <Typography key={`${script.language}-pending`} style={{ color: '#777' }}>
                                {`${langLabel} • audio non ancora pronto`}
                              </Typography>
                            );
                          }

                          return (
                            <Button
                              key={`${script.language}-download`}
                              disabled={downloading}
                              onClick={() => handleDownload(script.audio.file_url, script.audio.filename)}
                              style={{ justifyContent: 'left', paddingLeft: 0 }}
                            >
                              {langLabel}
                            </Button>
                          );
                        } else {
                          const versions = (script.videos || [])
                            .filter(v => v?.file_url)
                            .sort((a, b) => {
                              if (a.version === b.version) {
                                return (a.speedup || 0) - (b.speedup || 0)
                              }
                              return b.version - a.version // versão mais nova primeiro
                            })

                          if (!versions.length) {
                            return (
                              <Typography
                                key={`${script.language}-empty`}
                                style={{ padding: '0.25rem 0', color: customTheme.colors.ui.greyDark }}
                              >
                                Nessuna versione disponibile
                              </Typography>
                            )
                          }

                          return versions.map(video => {
                            const langLabel = languages.find(({ value }) => value === script.language)?.text || script.language.toUpperCase();
                            const speedLabel = Number(video.speedup).toFixed(1)

                            return (
                              <Button
                                key={`${script.language}-v${video.version}-${video.speedup}`}
                                disabled={downloading}
                                onClick={() => handleDownload(video.file_url, video.filename)}
                                style={{ justifyContent: 'left', paddingLeft: 0 }}
                              >
                                {`${langLabel} • ${video.version_label || `versione ${video.version}`} • velocità ${speedLabel}x`}
                              </Button>
                            )
                          })
                        }
                        

                      })}

                    </Box>
                  </Box>
                </Popover>
                }

                {currentPopoverEdit && (
                  <Popover
                    id={idEdit}
                    open={openEdit}
                    anchorEl={anchorElEdit}
                    onClose={handleClosePopoverEdit}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  >
                    <Box style={{ padding: '1rem', display: 'flex', flexDirection: 'column', minWidth: 280 }}>
                      <Button
                        onClick={() => {
                          setCurrentPopoverEdit(null)
                          // abre o modal em modo áudio, pré-preenchendo o texto atual
                          handleOpenModalEdit(currentPopoverEdit, 'audio')
                        }}
                        style={{ justifyContent: 'flex-start' }}
                      >
                        <CachedIcon style={{ marginRight: '0.5rem' }} />
                        Rigenera audio
                      </Button>

                      {/* <Button
                        onClick={() => {
                          // Mantém a funcionalidade antiga do "Sostituisci audio" (abrir modal de áudio)
                          setCurrentPopoverEdit(null)
                          handleOpenModalEdit(currentPopoverEdit, 'audio')
                        }}
                        style={{ justifyContent: 'flex-start' }}
                      >
                        <EditNoteOutlinedIcon style={{ marginRight: '0.5rem' }} />
                        Modifica audio
                      </Button> */}

                      <Button
                        disabled
                        onClick={() => {
                          // Criar funcionalidade de "Carica un tuo audio"
                          setCurrentPopoverEdit(null)
                          handleOpenModalEdit(currentPopoverEdit, 'audio')
                        }}
                        style={{ justifyContent: 'flex-start' }}
                      >
                        <FileUploadOutlinedIcon style={{ marginRight: '0.5rem' }} />
                        Carica un tuo audio
                      </Button>

                      <Button
                        onClick={() => {
                          const id = currentPopoverEdit.audio.id
                          setEditingSectionId(id)

                          const current = sectionRates[id] || 1
                          const idx = Math.max(0, SPEED_VALUES.findIndex(s => s === current))
                          setSectionSpeedIdx(idx === -1 ? 0 : idx)

                          setShowSpeedSlider(prev => !prev)
                        }}
                        style={{ justifyContent: 'flex-start', textAlign: 'left', width: '100%' }}
                      >
                        <FastForwardOutlinedIcon style={{ marginRight: '0.5rem' }} />
                        Cambia velocità
                      </Button>

                      {showSpeedSlider && (
                        <Box style={{ marginTop: 8, display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                          <Slider
                            value={sectionSpeedIdx}
                            step={1}
                            min={0}
                            max={SPEED_VALUES.length - 1}
                            marks={SPEED_MARKS}
                            onChange={(e, v) => {
                              setSectionSpeedIdx(v)
                              if (editingSectionId) {
                                setSectionRates(prev => ({ ...prev, [editingSectionId]: SPEED_VALUES[v] }))
                              }
                            }}
                            valueLabelDisplay="auto"
                            valueLabelFormat={v => SPEED_MARKS[v].label}
                          />
                        </Box>
                      )}

                    
                    </Box>
                  </Popover>
                )}


              </TableContainer>
            </>
          }
          
          
          {slide && slide?.presentation?.video_presentation_images?.length > 0 && <Box style={{ width: '100%', textAlign: 'center', marginTop:'3rem' }}>
            <Button color="primary" style={{ width: '10rem', }} 
              disabled={
                generating ||

                // !currentSlidEdit ||
                // !listEditedSlides.length ||
                regeneratingSections.size > 0 ||
                (!slideHasLegacyAudio && slide?.audio_status !== 'done')
              }
              onClick={handleGenerateEdit} variant='contained'>{generating ? <CircularProgress color='secondary' size={22} /> : 'Genera Video'}</Button>
          </Box>}
        </>
      </main>
}
    </AppBar>

  )
}

export default VideoComponent